import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const NameAndLogoContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const Logo = styled.img`
  width: ${props => props.theme.size.S};
`
